import summerPic from "@/public/images/artists/summer.png";
import { Artist } from "@/types/types";

export const summer = {
  id: "158",
  name: "Summer",
  image: summerPic,
  description: `Summer's voice is bright and agile, with a natural smoothness that makes her performances feel effortless. There's a youthful clarity in her tone, balanced by just enough grit to add depth and credibility. She moves fluidly between soft, delicate phrases and moments of sharp intensity, giving her sound both precision and a striking edge.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsummer-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Soul",
        "Rock",
        "Dance",
        "RnB",
        "Unprocessed",
        "Belting",
        "Deep",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 48,
        high: 75,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
